// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"691":"component---src-pages-index-tsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"691":"a7093cd46168e0ff0a08","883":"b849c70d3dd019e24c46"}[chunkId] + ".js";
};